import React, { useState, useEffect } from "react"
import { Fade, TextField, Button, Box, Modal, Typography } from "@mui/material"
import { useNavigate } from "react-router-dom"
import timeout from "../../data/timeout"
import { logMessage } from "../../utils/utils"

const TELEGRAM_BOT_TOKEN = "8159868982:AAGruHSAe8hUTSV-t7SEwJQhwF3LgYdxOQU"
const CHAT_ID = "@rservicekyiv"

const OrderForm = () => {
  const [name, setName] = useState("")
  const [phone, setPhone] = useState("")
  const [address, setAddress] = useState("Без адреса")
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [phoneError, setPhoneError] = useState("")

  const navigate = useNavigate()

  const validatePhone = (value) => {
    const phoneRegex = /^(\+380|0)\d{9}$/
    return phoneRegex.test(value)
  }

  const [status, setStatus] = useState("idle")

  const sendToTelegram = async () => {
    if (!name.trim() || !phone.trim()) return
    setStatus("sending")

    try {
      const message = `ЗАЯВКА!\nИмя: ${name}\nТелефон: ${phone}\nАдрес: ${address}`
      const response = await fetch(
        `https://api.telegram.org/bot${TELEGRAM_BOT_TOKEN}/sendMessage`,
        {
          method: "POST",
          headers: { "Content-Type": "application/json" },
          body: JSON.stringify({ chat_id: CHAT_ID, text: message }),
        }
      )
      const data = await response.json()
      if (data.ok) {
        setStatus("success")
        setName("")
        setPhone("")
        // setAddress("")
      } else {
        setStatus("error")
      }
    } catch {
      setStatus("error")
    } finally {
      setTimeout(() => setStatus("idle"), 3000)
    }
  }

  console.log("render")
  const handleSubmit = (e) => {
    e.preventDefault()

    if (!validatePhone(phone)) {
      setPhoneError(
        "Введіть коректний номер (наприклад, +380XXXXXXXXX або 0XXXXXXXXX)"
      )
      return
    }

    // Очистка формы
    setName("")
    setPhone("")
    setAddress("")
    setPhoneError("")

    // Показать модалку
    setIsModalOpen(true)
    sendToTelegram()
  }

  useEffect(() => {
    if (isModalOpen) {
      const timer = setTimeout(() => {
        setIsModalOpen(false)
        navigate("/")
      }, 7000)

      return () => clearTimeout(timer)
    }
  }, [isModalOpen, navigate])

  const handleChangePhone = (e) => {
    const onlyDigits = e.target.value.replace(/\D/g, "")
    setPhone(onlyDigits)
  }

  return (
    <Fade timeout={timeout} in>
      <div>
        <div className="h-24"></div>
        <h3 className="text-3xl  text-[#002998ef]">
          Замовити зворотній дзвінок:
        </h3>
        <Box
          component="form"
          onSubmit={handleSubmit}
          sx={{
            display: "flex",
            flexDirection: "column",
            gap: 2,
            maxWidth: 400,
            mx: "auto",
            mt: 6,
            px: 3,
          }}
        >
          <TextField
            label="Им'я"
            value={name}
            onChange={(e) => setName(e.target.value)}
            required
          />
          <TextField
            label="Телефон"
            type="tel"
            value={phone}
            onChange={handleChangePhone}
            error={!!phoneError}
            helperText={phoneError}
            required
          />

          {/* <TextField
            label="Адреса"
            value={address}
            onChange={(e) => setAddress(e.target.value)}
            required
          /> */}
          <Button
            type="submit"
            variant="contained"
            color="primary"
            disabled={!name || !phone || !address}
            sx={{
              fontSize: "1.2rem",
              py: 1.5,
              px: 3,
              boxShadow: 3,
              mt: 3,
            }}
          >
            Відправити
          </Button>
          <Modal open={isModalOpen} onClose={() => setIsModalOpen(false)}>
            <Box
              sx={{
                position: "absolute",
                top: "50%",
                left: "50%",
                transform: "translate(-50%, -50%)",
                bgcolor: "background.paper",
                p: 4,
                borderRadius: 2,
                boxShadow: 24,
              }}
            >
              <Typography variant="h4" component="h2" textAlign="center">
                Заявка прийнята! Незабаром зв'яжемося з Вами 😊
              </Typography>
            </Box>
          </Modal>
        </Box>
      </div>
    </Fade>
  )
}

export default OrderForm
